import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function WCXIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="WCX">
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 5.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V8.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M7.7 18.1l-1-4.9c0-.1 0-.2.1-.3.1-.1.2-.1.3-.1h.5c.1 0 .2 0 .3.1.1.1.1.2.2.3l.5 4 .5-4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1h.8c.1 0 .2 0 .3.1.1.1.2.2.2.3l.5 4 .5-4c0-.1.1-.2.2-.3.1-.1.2-.1.3-.1h.4c.1 0 .2 0 .3.1.1.1.1.2.1.3l-1 4.9c0 .1-.1.2-.2.3-.1.1-.2.1-.4.1H11c-.1 0-.2 0-.3-.1-.1-.1-.2-.2-.2-.3l-.5-4-.5 4c0 .1-.1.2-.2.3-.1.1-.2.1-.3.1h-.8c-.1 0-.3 0-.4-.1 0 0-.1-.1-.1-.3zm8.7.6c-.9 0-1.6-.3-2.1-.8s-.8-1.3-.8-2.2c0-.9.2-1.7.7-2.2.5-.5 1.2-.8 2-.8.4 0 .8 0 1.1.1.1 0 .2.1.3.2.1.1.1.2.1.4v.3c0 .1 0 .2-.1.3-.1.1-.2.1-.3.1-.3-.1-.6-.1-.9-.1-.5 0-.9.2-1.1.5-.2.1-.3.5-.3 1.2 0 .6.1 1.1.4 1.4.3.3.7.5 1.2.5.3 0 .6 0 .9-.1.1 0 .2 0 .3.1.1.1.1.2.1.3v.1c0 .1 0 .3-.1.4-.1.1-.2.2-.3.2-.3 0-.7.1-1.1.1zm2.8-.1c-.1 0-.2 0-.2-.1-.1-.1-.1-.2 0-.3l1.3-2.5v-.1l-1.2-2.4v-.3c.1-.1.1-.1.2-.1h.6c.1 0 .3 0 .4.1l.3.3.7 1.7.7-1.7c.1-.1.1-.2.2-.3.1-.1.2-.1.4-.1h.4c.1 0 .2 0 .2.1.1.1.1.2 0 .3L22 15.6v.1l1.3 2.5v.3c-.1.1-.1.1-.2.1h-.6c-.1 0-.3 0-.4-.1-.1-.1-.2-.2-.2-.3l-.7-1.7-.7 1.7c-.1.1-.1.2-.3.3-.1.1-.2.1-.4.1h-.6z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
